const scopes = Object.freeze({
  days: 'days',
});

export const reports = Object.freeze([
  {
    id: 'agp',
    scope: scopes.days,
  },
  {
    id: 'insulin',
    scope: scopes.days,
  },
  {
    id: 'nutrition',
    scope: scopes.days,
  },
  {
    id: 'exercise',
    scope: scopes.days,
  },
  /*
  {
    id: 'cycles',
    scope: scopes.days,
  },
  */
  {
    id: 'diary',
    scope: scopes.days,
  },
  {
    id: 'day',
    scope: scopes.days,
  },
]);

export const locales = {
  'de': 'Deutsch',
  'en-GB': 'English (GB)',
  'en-US': 'English (US)',
  'es': 'Español',
  'fr': 'Français',
  'it': 'Italiano',
  'no': 'Norsk',
  'fi': 'Suomi',
  'sv': 'Svenska',
};

export const defaultLocale = document.location.href.indexOf('sensotrend.fi') >= 0 ? 'fi' : 'en-GB';

export const initialLocale = (document.location.search.match(/([?&](l|locale))=([^&]*)/) || [])[3]
  || defaultLocale;
